import React, { useState } from 'react';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import Spinner from './spinner/Spinner';
import { axiosInstancev2 } from '../utils/Axios/axiosInterceptorv2';

function NotifyCohortStudentID({ cohortId, cohortName, toggleModal }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const mutation = useMutation(
    () => axiosInstancev2.post(`/cohorts/${cohortId}/notify-student-ids`),
    {
      onSuccess: (data) => {
        toast.success(
          data?.data?.message || 'Notifications queued successfully'
        );
        toggleModal();
      },
      onError: (error) => {
        toast.error(
          error?.response?.data?.error || 'Failed to trigger notifications'
        );
        setIsSubmitting(false);
      },
    }
  );

  const handleNotify = () => {
    setIsSubmitting(true);
    mutation.mutate();
  };

  return (
    <div className="space-y-4">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <p className="text-amber-800 text-sm font-medium mb-2">
          Important: Mass Notification
        </p>
        <p className="text-amber-700 text-xs">
          This will send an individual email to every student in{' '}
          <strong>{cohortName}</strong> who has been assigned a Student ID. The
          email will include their new ID and instructions on how to use it for
          login.
        </p>
      </div>

      <p className="text-gray-600 text-sm">
        Are you sure you want to notify all students in this cohort about their
        new Student IDs? This action cannot be undone once the emails are
        queued.
      </p>

      {isSubmitting ? (
        <div className="flex justify-center py-4">
          <Spinner />
        </div>
      ) : (
        <div className="flex justify-between mt-6">
          <button
            type="button"
            onClick={toggleModal}
            className="border border-gray-300 px-4 py-2 rounded-md text-gray-600 text-sm flex items-center space-x-2 hover:bg-gray-50 transition-colors"
          >
            <CancelIcon fontSize="inherit" />
            <span>Cancel</span>
          </button>
          <button
            type="button"
            onClick={handleNotify}
            className="bg-claret-500 px-6 py-2 rounded-md text-white text-sm font-bold flex items-center space-x-2 hover:bg-claret-600 transition-colors shadow-sm"
          >
            <SendIcon fontSize="inherit" />
            <span>Send Notifications</span>
          </button>
        </div>
      )}
    </div>
  );
}

export default NotifyCohortStudentID;
